"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "moncestino": {
    "1bea4d1b": [{
      "hkey": "f03ab382",
      "slug": "moncestino",
      "name": "Moncestino",
      "primary": true,
      "skipSearch": false
    }],
    "canoia": [{
      "hkey": "f03ab382",
      "slug": "moncestino",
      "name": "Moncestino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40ec4afd": [{
      "hkey": "f03ab382",
      "slug": "moncestino",
      "name": "Moncestino",
      "primary": true,
      "skipSearch": false
    }],
    "cignaretto": [{
      "hkey": "f03ab382",
      "slug": "moncestino",
      "name": "Moncestino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4cfed712": [{
      "hkey": "f03ab382",
      "slug": "moncestino",
      "name": "Moncestino",
      "primary": true,
      "skipSearch": false
    }],
    "piagera": [{
      "hkey": "f03ab382",
      "slug": "moncestino",
      "name": "Moncestino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;